import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  container: { height: "100%", padding: 10 },
  mb40: { marginBottom: 40 },
  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    marginBottom: 30,
    marginTop: 40,
  },
})
